import { FC, useEffect } from 'react';

import { ABHIAddonSubOptions } from '@healthquote/insurers';
import { HealthAddOn, useHealthQuoteStore } from '@store/healthquote';
import { Box, Modal, ModalProps } from '@ui';
import {
  ABCD,
  CHRONIC_CARE,
  HEALTH_INSURANCE_PRODUCTS,
  OPD
} from '@utils/constants';

import { AddOnMemberOptions } from './AddOnMemberOptions';

interface AddOnConfigModalProps extends ModalProps {
  addOn: HealthAddOn;
  productName: string;
}

const AddOnConfigModal: FC<AddOnConfigModalProps> = ({
  addOn,
  productName,
  onClose,
  ...rest
}) => {
  const { plan, resetDraftMembers } = useHealthQuoteStore((state) => ({
    plan: state.plan,
    resetDraftMembers: state.resetDraftMembers
  }));

  useEffect(() => {
    resetDraftMembers();
  }, [plan.members, addOn.key]);

  const handleCloseWithoutConfirm = () => {
    resetDraftMembers();
    onClose();
  };

  const renderContent = () => {
    //Activ One
    if (productName === HEALTH_INSURANCE_PRODUCTS.ACTIV_ONE) {
      if (addOn.key === OPD || addOn.key === CHRONIC_CARE) {
        return (
          <ABHIAddonSubOptions
            options={addOn?.subOptions[0]?.values}
            addOn={addOn}
            onClose={onClose}
            addOnName={addOn.name}
          />
        );
      }
    }
    // Activ Fit
    if (productName === HEALTH_INSURANCE_PRODUCTS.ACTIV_FIT) {
      if (addOn.key === OPD) {
        return (
          <AddOnMemberOptions
            title="OPD Expenses"
            addOn={addOn}
            closeDrawer={onClose}
          />
        );
      }
    }

    if (
      [
        HEALTH_INSURANCE_PRODUCTS.OPTIMA_SECURE,
        HEALTH_INSURANCE_PRODUCTS.OPTIMA_SECURE_PLUS,
        HEALTH_INSURANCE_PRODUCTS.OPTIMA_SUPER_SECURE
      ].includes(productName)
    ) {
      if (addOn.key === ABCD) {
        return (
          <AddOnMemberOptions title="ABCD" addOn={addOn} closeDrawer={onClose} />
        );
      }
    }
    return null;
  };

  return (
    <Modal
      centered
      onClose={handleCloseWithoutConfirm}
      size={612}
      {...rest}
      noContentPadding
      bottomSheet
    >
      <Box p={32} pt={16}>
        {renderContent()}
      </Box>
    </Modal>
  );
};

export { AddOnConfigModal };
